module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('v-layout', {
    staticClass: "menu-acces menubots",
    attrs: {
      "text-xs-right": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "mr-5": ""
    }
  }, [_c('ul', {
    attrs: {
      "aria-label": "recursos educativos"
    }
  }, _vm._l((_vm.listBots), function(bot, index) {
    return _c('li', {
      key: index,
      staticClass: "back-red",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showVideo(index)
        }
      }
    }, [_c('button', {
      staticClass: "hvr-grow",
      class: ('bot-' + index),
      attrs: {
        "id": 'footer-bot-' + index,
        "aria-label": bot.name
      }
    })])
  }))])], 1), _vm._v(" "), (_vm.modalOne) ? _c('v-dialog', {
    attrs: {
      "width": "900",
      "role": "dialog",
      "aria-label": "glosario"
    },
    model: {
      value: (_vm.modalOne),
      callback: function($$v) {
        _vm.modalOne = $$v
      },
      expression: "modalOne"
    }
  }, [_c('v-card', {
    staticClass: "pt-4 pb-4 pl-4 pr-4 align-center"
  }, [_c('h3', {
    staticClass: "title-peq"
  }, [_vm._v(_vm._s(_vm.nameMod))]), _vm._v(" "), (_vm.content.glosario) ? _c('div', [_c('ui-glosario', {
    ref: "glosario",
    attrs: {
      "glosario": _vm.verglosario
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.content.bibliografia) ? _c('div', [_c('ui-bibliografia')], 1) : _vm._e(), _vm._v(" "), (_vm.content.creditos) ? _c('div', [_c('ui-creditos')], 1) : _vm._e(), _vm._v(" "), (_vm.content.videos) ? _c('div', [_c('ui-videos')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('ui-button', {
    attrs: {
      "primary": "",
      "content": "Cerrar contenido",
      "aria": "Cerrar contenido"
    },
    nativeOn: {
      "click": function($event) {
        _vm.cerrarModal()
      }
    }
  })], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bcf634e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Footer.vue
// module id = 1040
// module chunks = 1